const SIDEBAR_SECTIONS = [
  {
    id: 'overview',
    label: 'Overview',
    items: [
      {
        id: 'command-centre',
        label: 'Command centre',
        icon: 'bi-grid-3x3-gap',
        route_name: 'CommandCentre',
        badge: 'Live',
        badge_class: 'bg-light text-secondary border border-light'
      },
      {
        id: 'my-tasks',
        label: 'My tasks',
        icon: 'bi-check2-square',
        route_name: 'MyTasks',
        count: '14',
        count_class: 'bg-warning-subtle text-warning-emphasis'
      },
      {
        id: 'workflows',
        label: 'Workflows',
        icon: 'bi-diagram-3',
        route_name: 'Workflows',
        count: '39',
        count_class: 'bg-secondary-subtle text-secondary-emphasis'
      },
      {
        id: 'delegation',
        label: 'Delegation of authority',
        icon: 'bi-sign-turn-slight-right',
        route_name: 'DelegationOfAuthority',
        count: '3',
        count_class: 'bg-danger-subtle text-danger-emphasis'
      },
      {
        id: 'onboarding-handoff',
        label: 'Onboarding handoff',
        icon: 'bi-box-arrow-up-right',
        route_name: 'OnboardingHandoff',
        badge: 'Sync',
        badge_class: 'bg-light text-secondary border border-light'
      }
    ]
  },
  {
    id: 'governance-controls',
    label: 'Governance & controls',
    items: [
      { id: 'governance', label: 'Governance', icon: 'bi-building', route_name: 'Governance', count: null },
      { id: 'obligations-register', label: 'Obligations register', icon: 'bi-list-check', route_name: 'ObligationsRegister', count: '2', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'policies', label: 'Policies', icon: 'bi-file-earmark-text', route_name: 'CompliancePolicies', count: null },
      { id: 'controls-library', label: 'Controls library', icon: 'bi-shield-check', route_name: 'ControlsLibrary', count: '86', count_class: 'bg-secondary-subtle text-secondary-emphasis' },
      { id: 'exceptions-deviations', label: 'Exceptions & deviations', icon: 'bi-slash-circle', route_name: 'ExceptionsDeviations', count: '1', count_class: 'bg-success-subtle text-success-emphasis' }
    ]
  },
  {
    id: 'business-compliance',
    label: 'Business compliance',
    items: [
      { id: 'third-parties', label: 'Third parties & suppliers', icon: 'bi-truck', route_name: 'SupplierRegister', count: '12', count_class: 'bg-warning-subtle text-warning-emphasis' },
      { id: 'procurement', label: 'Procurement', icon: 'bi-cart3', route_name: 'ComplianceProcurement', count: '8', count_class: 'bg-warning-subtle text-warning-emphasis' },
      { id: 'finance', label: 'Finance', icon: 'bi-wallet2', route_name: 'FinanceCompliance', count: '11', count_class: 'bg-warning-subtle text-warning-emphasis' },
      { id: 'contracts-obligations', label: 'Contracts & obligations', icon: 'bi-archive', route_name: 'ContractLifecycle', count: '9', count_class: 'bg-warning-subtle text-warning-emphasis' },
      { id: 'assets', label: 'Assets', icon: 'bi-box', route_name: 'AssetRegister', count: null },
      { id: 'facilities-sites', label: 'Facilities & sites', icon: 'bi-shop', route_name: 'FacilitiesSites', count: '1', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'employees', label: 'Employees', icon: 'bi-people', route_name: 'EmployeeRegister', count: null },
      { id: 'training', label: 'Training', icon: 'bi-mortarboard', route_name: 'TrainingProgram', count: null }
    ]
  },
  {
    id: 'risk-assurance',
    label: 'Risk & assurance',
    items: [
      { id: 'risks', label: 'Risks', icon: 'bi-exclamation-triangle', route_name: 'RisksDashboard', count: '7', count_class: 'bg-warning-subtle text-warning-emphasis' },
      { id: 'incidents-cases', label: 'Incidents & cases', icon: 'bi-bell', route_name: 'IncidentsCases', count: null },
      { id: 'corrective-actions', label: 'Corrective actions', icon: 'bi-list-check', route_name: 'FindingsCorrectiveActions', count: '10', count_class: 'bg-warning-subtle text-warning-emphasis' },
      { id: 'conflicts-of-interest', label: 'Conflicts of interest', icon: 'bi-person-exclamation', route_name: 'ConflictsOfInterest', count: null },
      { id: 'legal-matters', label: 'Legal matters', icon: 'bi-briefcase', route_name: 'LegalMattersLitigation', count: '1', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'complaints-grievances', label: 'Complaints & grievances', icon: 'bi-chat-left-text', route_name: 'ComplaintsGrievances', count: '2', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'audits-findings', label: 'Audits & findings', icon: 'bi-clipboard-check', route_name: 'AuditsRegister', count: null },
      { id: 'ethics-whistleblowing', label: 'Ethics & whistleblowing', icon: 'bi-megaphone', route_name: 'EthicsWhistleblowing', count: '2', count_class: 'bg-danger-subtle text-danger-emphasis' }
    ]
  },
  {
    id: 'data-security-records',
    label: 'Data, security & records',
    items: [
      { id: 'data-privacy', label: 'Data privacy', icon: 'bi-lock', route_name: 'DataPrivacy', count: null },
      { id: 'it-security', label: 'IT security', icon: 'bi-shield-lock', route_name: 'ItSecurity', count: null },
      { id: 'records-retention', label: 'Records & retention', icon: 'bi-folder2', route_name: 'RecordsRetention', count: null },
      { id: 'business-continuity', label: 'Business continuity', icon: 'bi-arrow-repeat', route_name: 'BusinessContinuity', count: null }
    ]
  },
  {
    id: 'operational-compliance',
    label: 'Operational compliance',
    items: [
      { id: 'hse', label: 'Health, safety & environment', icon: 'bi-heart-pulse', route_name: 'HealthSafetyEnvironment', count: '2', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'licences-permits', label: 'Licences & permits', icon: 'bi-passport', route_name: 'LicencesPermitsCertifications', count: '1', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'insurance-claims', label: 'Insurance & claims', icon: 'bi-shield-plus', route_name: 'InsuranceClaims', count: null },
      { id: 'service-delivery', label: 'Service delivery', icon: 'bi-geo-alt', route_name: 'ServiceDeliveryPerformance', count: '1', count_class: 'bg-danger-subtle text-danger-emphasis' },
      { id: 'grant-funding', label: 'Grant & funding', icon: 'bi-cash-coin', route_name: 'GrantFundingCompliance', count: '1', count_class: 'bg-danger-subtle text-danger-emphasis' }
    ]
  },
  {
    id: 'evidence-reporting',
    label: 'Evidence & reporting',
    items: [
      { id: 'regulatory-calendar', label: 'Regulatory calendar', icon: 'bi-calendar3', route_name: 'RegulatoryCalendar', count: null },
      { id: 'evidence-vault', label: 'Evidence vault', icon: 'bi-folder2', route_name: 'EvidenceVault', count: null },
      { id: 'reports', label: 'Reports', icon: 'bi-bar-chart', route_name: 'ReportsDashboard', count: null },
      { id: 'board-audit-packs', label: 'Board & audit packs', icon: 'bi-briefcase', route_name: 'BoardAuditPacks', count: null }
    ]
  },
  {
    id: 'administration',
    label: 'Administration',
    items: [
      { id: 'organisation-structure', label: 'Organisation structure', icon: 'bi-diagram-2', route_name: 'OrganisationStructure', count: null },
      { id: 'users-roles', label: 'Users & roles', icon: 'bi-people', route_name: 'UsersRoles', count: null },
      { id: 'master-data', label: 'Master data', icon: 'bi-folder', route_name: 'MasterData', count: null },
      { id: 'integrations', label: 'Integrations', icon: 'bi-link-45deg', route_name: 'Integrations', count: null },
      { id: 'system-settings', label: 'System settings', icon: 'bi-gear', route_name: 'SystemSettings', count: null }
      ]
    }
  ];

export default {
  name: 'ConfigGlobalSidebar',
  data: () => ({
    active_menu_id: 'command-centre',
    sidebar_sections: SIDEBAR_SECTIONS
  }),
  computed: {
    logo_src() {
      return this.$clientLogo || require('@/assets/images/complyon/logos/complyon_logo_business.png');
    },
    current_user_name() {
      return this.$store.getters.currentLeadName || '';
    },
    current_user_role() {
      return this.$store.getters.currentRole || '';
    },
    current_user_initials() {
      const initials = this.current_user_name
        .split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();

      return initials || 'PN';
    }
  },
  mounted() {
    this.sync_active_menu_with_route();
  },
  watch: {
    '$route.name'() {
      this.sync_active_menu_with_route();
    }
  },
  methods: {
    sync_active_menu_with_route() {
      const matched_item = this.sidebar_sections
        .flatMap((section) => section.items)
        .find((item) => item.route_name === this.$route.name);

      if (matched_item?.id) {
        this.active_menu_id = matched_item.id;
      }
    },
    set_active_menu(item_id) {
      this.active_menu_id = item_id;

      const target_item = this.sidebar_sections
        .flatMap((section) => section.items)
        .find((item) => item.id === item_id);

      if (target_item?.route_name && this.$route.name !== target_item.route_name) {
        this.$router.push({ name: target_item.route_name });
      }

      this.close_sidebar();
    },
    is_active_menu(item) {
      return this.active_menu_id === item.id || this.$route.name === item.route_name;
    },
    sign_out() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('otp_verified');
      sessionStorage.removeItem('is_aic_one_login');
      sessionStorage.removeItem('auth_redirect_reason');
      this.$store.dispatch('resetStore');
      this.$router.push({ name: 'UserLogin' });
    },
    close_sidebar() {
      if (window.innerWidth < 992) {
        this.$emit('close');
      }
    }
  }
};
